var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-container__header",class:{
      '-background': ['result', 'register', 'completion'].includes(
        _vm.currentRoute
      ),
      '-hidden': ['loading'].includes(_vm.currentRoute)
    }},[_c('Header',{attrs:{"title":_vm.introSettings.title,"mini":_vm.currentRoute !== 'home',"expanded":[
          _vm.Routes.result.name,
          _vm.Routes.register.name,
          _vm.Routes.completion.name
        ].includes(_vm.currentRoute)}})],1),_c('div',{staticClass:"header-container__header",class:{
      '-hidden': [
        _vm.Routes.home.name,
        _vm.Routes.quiz.name,
        _vm.Routes.loading.name
      ].includes(_vm.currentRoute)
    }},[_c('Header',{attrs:{"mini":"","light":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }